import { SystemField } from "./system-field";

export class TransferProdDetail extends SystemField{
     
     transfer_product_id?:string;
     product_id?:string;
     trans_uom_id?:string;
     base_uom_id?:string;
     from_location_id?:string;
     to_location_id?:string;
     langs?: any;
}
export class TransferProdDetailTranslate extends SystemField{
     
     lang_code?:string;
     description?:string;
     transf_prod_detail_id?:string;

}
